import { styled } from 'styled-components'
import COLORS from '@ui-components/colors'
import SHADOWS from '@ui-components/shadows'

export const Overlay = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  min-width: 100%;
  position: fixed;
  top: 0;
  z-index: 100;
`

export const Content = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: 0.625rem;
  box-shadow: ${SHADOWS.BUTTON_SHADOW};
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
`
